"use client";
//#region packages/@mantine/core/src/components/Overlay/Overlay.module.css
var Overlay_module_default = { "root": "m_9814e45f" };
//#endregion
export { Overlay_module_default as default };

//# sourceMappingURL=Overlay.module.mjs.map